import { useEffect } from 'react';
import { ROLES } from 'src/types/Employee';
import {
  IDiner,
  ISearchResults,
  useDinerSearch,
} from 'src/utilities/useSearchHooks';

export type UseGetParentAdminsReturn = {
  searchResults: ISearchResults<IDiner>;
};

export const useGetParentAdmins = (
  corpId: string,
  pageSize: number
): UseGetParentAdminsReturn => {
  const searchResults = useDinerSearch(corpId, {
    diner_role: ROLES.CORP_PARENT_ADMIN,
    size: pageSize,
  });

  useEffect(() => {
    searchResults.doSearch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return { searchResults };
};
